export default __webpack_public_path__ + "static/media/BlueBall.9290ba9e.svg";